<template>
  <div class="">
    <div class="form-control relative flex h-9 items-center gap-2">
      <div class="w-100 flex items-center gap-1">
        <label :for="`${id}-min`" class="text-sm font-medium opacity-70">
          {{ $t('control.from') }}
        </label>
        <input
          :id="`${id}-min`"
          :value="internalValue[0]"
          class="w-full outline-none"
          type="text"
          @change="
            handleChange($event, [$event.target.value, internalValue[1]])
          "
          @keypress="isNumber"
        />
      </div>

      <div class="w-100 flex items-center gap-1">
        <label :for="`${id}-max`" class="text-sm font-medium opacity-70">
          {{ $t('control.to') }}
        </label>
        <input
          :id="`${id}-max`"
          :value="internalValue[1]"
          class="w-full outline-none"
          type="text"
          @change="
            handleChange($event, [internalValue[0], $event.target.value])
          "
          @keypress="isNumber"
        />
      </div>
    </div>
    <VueSlider
      v-model="internalValue"
      class="-mt-2 w-full shrink-0 select-none !px-2"
      :direction="currentLanguage?.is_rtl ? 'rtl' : 'ltr'"
      :dot-options="{
        tooltip: 'none',
        contained: true,
        enableCross: false,
        interval: 0.1,
        // silent: true,
      }"
      :max="max"
      :min="min"
      :min-range="1"
      @change="onSliderChange"
    >
    </VueSlider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { mapGetters } from 'vuex';

export default {
  name: 'RangeFilter',
  components: {
    VueSlider,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },

  //   emits: ['update:modelValue'],

  data() {
    return {
      internalValue: [...this.value],
    };
  },
  computed: {
    ...mapGetters(['currentLanguage']),
  },
  watch: {
    value: {
      handler(newVal) {
        this.internalValue = [...newVal];
      },
      deep: true,
    },
  },
  methods: {
    isNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    handleChange(e, val) {
      const range = this.checkRangeValues(val, this.min, this.max);
      //   this.internalValue = range;
      this.$emit('input', range);
    },

    onSliderChange(val) {
      this.$emit('input', val);
    },

    checkRangeValues(val, min, max) {
      let first = Number(val[0]);
      let second = Number(val[1]);

      if (isNaN(first)) first = min;
      if (isNaN(second)) second = max;

      if (first >= second) {
        first = second - 1;
      } else if (second < first) {
        second = first + 1;
      }

      if (first < min) {
        first = Number(min);
      }
      if (first > max) {
        first = Number(max - 1);
      }
      if (second > max) {
        second = Number(max);
      }
      if (second <= min) {
        second = Number(min + 1);
      }

      return [first, second];
    },
  },
};
</script>
